import React, {Component} from 'react'
import {TextField, DateTimePicker, MemberTitle, Markdown, LinkButton} from 'components'
import {Authorization, humanize} from 'utils'
import FormContext from 'components/FormContext'
import Typography from '@material-ui/core/Typography'
import styles from './styles'
import {ReadOnly, TextAgreement} from 'components'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from 'components/styled/Checkbox';
import {FormattedMessage} from 'react-intl'

export class Register extends Component {
  state = {showTncs: false}

  static defaultProps = {
    name: 'account.steps.register',
  }

  get registeredFor() {
    return this.props.context.registeredFor
  }

  get accountInfoHeading() {
    return (this.registeredFor === 'individual' ? 'Personal' : humanize(this.registeredFor)) + ' Info'
  }

  get nameLabel() {
    return (this.registeredFor === 'individual' ? 'Full' : humanize(this.registeredFor)) + ' Name'
  }

  get dateLabel() {
    return (this.registeredFor === 'individual' ? 'Date of Birth' : 'Date of Registration')
  }

  handleShowTncs = () => {
    this.setState({showTncs: true})
  }

  handleTncs = () => {
    if (!this.props.context.tncsAgreedAt)
      this.setState({showTncs: true})
    else
      this.handleTncsAgreed(false)()
  }

  handleTncsAgreed = (tncsAgreedAt) => () => {
    this.setState({showTncs: false})
    if (!this.props.context.limitedUpdate) {
      this.props.onChange({...this.props.context, tncsAgreedAt})
    }
  }

  handleShowCert = () => {
    this.setState({showCert: true})
  }

  handleCert = () => {
    if (!this.props.context.certificationViewedAt)
      this.setState({showCert: true})
    else
      this.handleCertAccepted(false)()
  }

  handleCertAccepted = (certificationViewedAt) => () => {
    this.setState({showCert: false})
    if (!this.props.context.limitedUpdate) {
      this.props.onChange({...this.props.context, certificationViewedAt})
    }
  }

  render = () => {
    const {review, context, onChange, errorContext, metaRef} = this.props
    const {limitedUpdate} = context
    const accountType = context.type === 'issuerAccounts' ? 'issuer' : 'investor'
    return (
      <ReadOnly on={review}>
        <FormContext context={context} onChange={onChange} errorContext={errorContext} metaRef={metaRef}>
          <div className={styles.section}>
            <MemberTitle member='registeredFor' required>
              <FormattedMessage id={`account.steps.register.account_type_title.${accountType}`} />
            </MemberTitle>
            <RadioGroup name='registeredFor1' member='registeredFor' required doesNotDisplayErrors>
              <FormControlLabel value="individual" control={<Radio disabled={this.props.review || limitedUpdate}/>}
                                label="Individual (Yourself)"/>
              <FormControlLabel value="company" control={<Radio disabled={this.props.review || limitedUpdate}/>}
                                label="Company"/>
              <FormControlLabel value="trust" control={<Radio disabled={this.props.review || limitedUpdate}/>}
                                label="Trust"/>
              <FormControlLabel value="partnership" control={<Radio disabled={this.props.review || limitedUpdate}/>}
                                label="Partnership"/>
            </RadioGroup>
          </div>

          <Collapse in={!!this.registeredFor}>
            <div className={styles.section}>
              <Typography variant='h6'>{this.accountInfoHeading}</Typography>
              <TextField autoFocus label={this.nameLabel} member='accountName' disabled={limitedUpdate} fullWidth required/>
              <TextField label='Address 1' member='address1' fullWidth required/>
              <TextField label='City' member='city' required/>
              <TextField label='Zip/Postal Code' member='postalCode' required/>
              {context.country &&
                <TextField label='Country' member='country.name' disabled fullWidth meta={{prepopulated: true}}/>
              }
              <DateTimePicker showDate label={this.dateLabel} member='dob' timezone={'Etc/UTC'}
                              className={styles.fullWidth} openToYearSelection required/>
              <TextField label='Telephone' member='telephone' fullWidth required/>
            </div>

            <div className={styles.section}>
              {!Authorization.admin &&
                <MemberTitle
                  variant='body1' member='tncsAgreedAt' required
                  meta={{requiredError: 'You must agree to the terms and conditions to register your account',
                         errorLabel: 'Terms And Conditions'}}
                >
                  <Checkbox
                    style={{marginLeft: -12}}
                    onClick={this.handleTncs}
                    checked={!!this.props.context.tncsAgreedAt}
                    disabled={limitedUpdate}
                  />I have read and understood the <LinkButton onClick={this.handleShowTncs}>Terms and Conditions</LinkButton>
                </MemberTitle>
              }

              {this.props.certAgreement &&
                <div className={styles.checkContainer}>
                  <Checkbox
                    style={{marginLeft: -12}}
                    onClick={this.handleCert}
                    checked={!!this.props.context.certificationViewedAt}
                    disabled={limitedUpdate}
                  />
                  <MemberTitle
                    variant='body1' member='certificationViewedAt' required
                    meta={{requiredError: 'You must accept the certification conditions to register your account',
                           errorLabel: 'Wholesale or Accredited Investor'}}
                  >
                    I understand that there is a <LinkButton onClick={this.handleShowCert}>minimum purchase requirement</LinkButton> of $100,000 NZD
                  </MemberTitle>
                </div>
              }

              <TextAgreement
                title='Terms and Conditions'
                open={this.state.showTncs}
                onConfirm={this.handleTncsAgreed(this.props.tncs.downloadedAt)}
                onCancel={this.handleTncsAgreed(false)}
                disabled={limitedUpdate}
              >
                <Markdown mdtext={this.props.tncs.renderedContent} />
              </TextAgreement>

              {this.props.certAgreement &&
                <TextAgreement
                  title='Certification'
                  open={this.state.showCert}
                  onConfirm={this.handleCertAccepted(this.props.certAgreement.downloadedAt)}
                  onCancel={this.handleCertAccepted(false)}
                  disabled={limitedUpdate}
                >
                  <Markdown mdtext={this.props.certAgreement.renderedContent} />
                </TextAgreement>
              }
            </div>
          </Collapse>
        </FormContext>
      </ReadOnly>
    )
  }
}